<ng-container *transloco="let t">
  <div class="flex w-full min-w-0">
    <button
      iButton
      variant="secondary"
      class="w-full min-w-0"
      [testId]="testId ?? undefined"
      [disabled]="disabled()"
      (click)="openMediaSelectionModal()"
    >
      <IIcon name="fileImage" />
      {{ newFile() ? newFile()!.name : _savedMedia() ? _savedMedia()!.name : t("media-input.select_a_file") }}
    </button>
    @if (_savedMedia() || newFile()) {
      <button
        iButton
        variant="secondary"
        class="ml-2 flex-none"
        [iTooltip]="t('media-input.preview_file')"
        (click)="openMediaToPreview()"
      >
        <IIcon name="eye" />
      </button>
    }
    @if (removable) {
      <button
        iButton
        variant="secondary"
        class="ml-2 flex-none"
        [iTooltip]="t('media-input.remove_file')"
        (click)="removeFile()"
      >
        <IIcon name="trash" />
      </button>
    }
  </div>
</ng-container>
